import { ComponentType } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { setTopNotificationBlockShown } from 'store/entities/localSettings/actions'
import HeaderNotification from './HeaderNotification'
import { HeaderNotificationPropType } from './HeaderNotification.interface'

const mapDispatchToProps = {
  setTopNotificationBlockShown,
}

export default connect(
  null,
  mapDispatchToProps
)(withTranslation('user')(HeaderNotification) as ComponentType) as ComponentType<HeaderNotificationPropType>
